import { useContext, useState } from 'react';
import {
    Button, Card, Col, Modal, PageHeader, Row,
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
    AlertData, AlertsList, PreviewAlert,
} from './components';
import { AlertsContext } from './context/alerts.context';
import Send from './components/Send';
import { WorkspaceInfo } from '../../types/bookingRequests';

const { confirm } = Modal;

const Alerts = () => {
    const {
        alert, form, workspaceAlerts, loadingSendAlert, loadingWorkspaceAlerts, sendAlert, sendProgrammedAlert, markAsRead, loadingReadAlert, updateAlert,
    } = useContext(AlertsContext);

    const [showPreview, setShowPreview] = useState<boolean>(false);
    const [alertData, setAlertData] = useState<{ option: number; country: string; workspaceIds: WorkspaceInfo[] }>({
        option: 1,
        country: 'EC',
        workspaceIds: [],
    });

    const COUNTRIES: Record<string, string> = {
        EC: 'Ecuador',
        MX: 'México',
        DO: 'República Dominicana',
        PE: 'Perú',
        CO: 'Colombia',
        GT: 'Guatemala',
        CR: 'Costa Rica',
        CL: 'Chile',
        AR: 'Argentina',
        UY: 'Uruguay',
        PA: 'Panamá',
    };

    const handleSendAlert = () => {
        let message = '';

        if (alertData.option === 1) {
            const countryName = COUNTRIES[alertData.country] || alertData.country;
            message = `Se enviará la alerta a todos los clientes de ${countryName}, ¿Estás seguro de que deseas continuar?`;
        } else {
            const workspacesCount = alertData.workspaceIds.length;
            message = `Se enviará una alerta a ${workspacesCount} workspace${workspacesCount !== 1 ? 's' : ''}, ¿Estás seguro de que deseas continuar?`;
        }

        confirm({
            title: 'Confirmarción de envío de alerta',
            icon: <ExclamationCircleOutlined />,
            content: message,
            okText: 'Sí, enviar',
            cancelText: 'Cancelar',
            onOk() {
                form.submit();
            },
        });
    };

    const extra = [
        <Button
            type="ghost"
            onClick={() => setShowPreview(true)}
        >
            Alert Preview
        </Button>,
        <Button
            type="primary"
            loading={loadingSendAlert}
            onClick={handleSendAlert}
        >
            Send alert
        </Button>,
    ];

    return (
        <Row justify="space-between" align="top" gutter={[24, 32]}>
            {
                showPreview && (
                    <Modal
                        open={showPreview}
                        onCancel={() => setShowPreview(false)}
                        footer={null}
                        width={800}
                        centered
                    >
                        <PreviewAlert
                            alert={alert}
                        />
                    </Modal>
                )
            }

            <Col xs={24} xl={8}>
                <AlertsList />
            </Col>
            <Col xs={24} xl={16}>
                <Card bordered>
                    <PageHeader
                        title=""
                        style={{ paddingRight: 12 }}
                        extra={extra}
                    />
                    <div
                        style={{
                            paddingRight: 12,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignContent: 'center',
                            height: '75vh',
                            overflowY: 'scroll',
                        }}
                    >
                        <Row justify="space-between" align="top" gutter={[24, 24]}>
                            <Col xs={24}>
                                <Send
                                    form={form}
                                    alert={alert}
                                    loadingSendAlert={loadingSendAlert}
                                    sendAlert={sendAlert}
                                    sendProgrammedAlert={sendProgrammedAlert}
                                    onDataChange={setAlertData}
                                />
                            </Col>
                            <Col xs={24}>
                                <AlertData
                                    alert={alert}
                                    markAsRead={markAsRead}
                                    loadingReadAlert={loadingReadAlert}
                                    loadingWorkspaceAlerts={loadingWorkspaceAlerts}
                                    workspaceAlerts={workspaceAlerts}
                                    updateAlert={updateAlert}
                                />
                            </Col>
                        </Row>
                    </div>
                </Card>
            </Col>
        </Row>
    );
};

export default Alerts;
